<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-上传设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--文件上传设置-->
      <div class="common-form">快捷生成代码</div>


      <el-form-item label="appid" prop="type" >
            <el-radio-group v-model="form.type">
              <el-radio  :label="0">快速生成应用</el-radio>
                <el-radio  :label="1">基础获取代码</el-radio>
                <el-radio  :label="2">基础修改代码</el-radio>
                <el-radio  :label="3">数据快速生成数组</el-radio>
                 <el-radio  :label="4">快速生成装修组件</el-radio>
            </el-radio-group>
      </el-form-item>


   <div v-if="form.type == 4">

      <el-form-item label="组件名称" prop="table" >
        <el-input v-model="form.zname" type="text"  placeholder="请输入组件名称" style="width: 200px;">
        </el-input>
      </el-form-item>


        <el-form-item label="组件名称（英文）" prop="table" >
         <el-input v-model="form.znameen" type="text"  placeholder="请输入组件名称（英文）" style="width: 200px;">
        </el-input>
      </el-form-item>


     <el-form-item label="shop端路径" prop="table" >
         <el-input v-model="form.shoppath" type="text"  placeholder="请输入shop端路径" style="width: 500px;">
        </el-input>
      </el-form-item>

           <el-form-item label="php端路径" prop="table" >
         <el-input v-model="form.phppath" type="text"  placeholder="请输入php端路径" style="width: 500px;">
        </el-input>
      </el-form-item>

        <el-form-item label="uniapp端路径" prop="table" >
         <el-input v-model="form.uniapppath" type="text"  placeholder="请输入uniapp端路径" style="width: 500px;">
        </el-input>


      </el-form-item>

  
   </div>


   <div v-if="form.type == 1 || form.type == 2">

    <el-form-item label="表名" prop="table" >
        <el-input v-model="form.table" type="text"  placeholder="请输入表名(app)" style="width: 200px;">
        </el-input>
      </el-form-item>


      <el-form-item label="主键" prop="table" >
        <el-input v-model="form.id" type="text"  placeholder="请输入主键" style="width: 200px;">
        </el-input>
      </el-form-item>

      <el-form-item label="方法备注" prop="table" >
        <el-input v-model="form.note" type="text"  placeholder="请输入方法备注(获取列表)" style="width: 200px;">
        </el-input>
      </el-form-item>

      
      <el-form-item label="条件" prop="table" >
        <el-input v-model="form.condi" type="textarea"  placeholder="请输入条件(user_id:self.user_id;app_id:self.app_id;)" 
        style="width: 300px;">
        </el-input>
      </el-form-item>


      <el-form-item label="放在哪个控制器下" prop="table" >
        <el-input v-model="form.putController" type="text"  placeholder="请输入放在哪个控制器下(plus.horder.Horder)" style="width:300px;">
        </el-input>
      </el-form-item>


      <el-form-item label="修改数据" prop="table" >
        <el-input v-model="form.updateData" type="text"  placeholder="请输入修改数据(ins_user_id:)" style="width:300px;">
        </el-input>
      </el-form-item>
   </div>


   <div v-if="form.type == 3">
            
    <el-form-item label="条件" prop="table" >
        <el-input v-model="form.condi" rows="15" type="textarea"  placeholder="请输入条件(user_id ad_id)" 
        style="width: 300px;">
        </el-input>
      </el-form-item>


   </div>


  
      <div v-for="(item,index) in result" :key="index">
        <el-form-item :label="item.text" prop="days" >
        <div style="overflow-y: 500px;width: 1000px; white-space: pre-line;" >
            {{  item.val }}

        </div>

      </el-form-item>


      </div>


      <div v-if="form.type == 4"> 
          <el-button size="small" type="primary" @click="onSubmitdiyz(1)" :disabled="loading">生成装修组件</el-button>
          <el-button size="small" type="primary" @click="onSubmitdiyz(2)" :disabled="loading">修改装修组件</el-button>
          <el-button size="small" type="primary" @click="deldiyz(1)" :disabled="loading">删除装修组件</el-button>


          <div>用法如下：</div>
          <div>1、自动生成shop下的parmas、model文件</div>
          <div>2、自动生成uniapp下的components/diy文件</div>
          <div>3、手动在shop：src/views/page/page/diy/Params.vue 去引入页面</div>
          <div>4、手动在shop：src/views/page/page/diy/Model.vue 去引入页面</div>
          <div>5、手动在uniapp：components/diy/diy.vue 去引入页面</div>
      </div>





    <el-form v-if="form.type == 0" size="small" ref="form" :model="formplus" label-width="150px">

        <el-form-item label="应用名称" prop="plus_name" >
          <el-input v-model="formplus.plus_name" min=10 class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="应用名称（英文）" prop="plus_name_en" >
          <el-input v-model="formplus.plus_name_en"  min=10 class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="域名" prop="hosturl" >
          <el-input v-model="formplus.hosturl"  min=10 class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="shop端生成路径" prop="shop_gen_url" >
          <el-input v-model="formplus.shop_gen_url"  min=10 class="max-w460"></el-input>

          <div>路径后一定不能跟shop</div>
        </el-form-item>
        <el-form-item label="php端生成路径" prop="php_gen_url" >
          <el-input v-model="formplus.php_gen_url"  min=10 class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="权限菜单最高价ID（用于删除）" prop="new_access_id" >
          <el-input v-model="formplus.new_access_id"  min=10 class="max-w460"></el-input>
        </el-form-item>
     

        <el-form-item label="操作" prop="" >
          <el-button size="small" type="primary" @click="onSubmitPlus(1)" :disabled="loading">生成前端</el-button>
          <el-button size="small" type="primary" @click="onSubmitPlus(2)" :disabled="loading">删除前端</el-button>
          <el-button size="small" type="primary" @click="onSubmitPlus(3)" :disabled="loading">生成后端</el-button>
          <el-button size="small" type="primary" @click="onSubmitPlus(4)" :disabled="loading">删除后端</el-button>

          <el-button size="small" type="primary" @click="onSubmitPlus(5)" :disabled="loading">创建数据库表</el-button>
          <el-button size="small" type="primary" @click="onSubmitPlus(6)" :disabled="loading">删除表</el-button>

          <el-button size="small" type="primary" @click="onSubmitPlus(7)" :disabled="loading">生成权限菜单</el-button>
          <el-button size="small" type="primary" @click="onSubmitPlus(8)" :disabled="loading">删除权限菜单</el-button>

          <el-button size="small" type="primary" @click="onSubmitPlus(9)" :disabled="loading">删除设置表</el-button>

         
        </el-form-item>


    </el-form>
   



      <!--提交-->
      <div class="common-button-wrapper" v-if="form.type != 0"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>

    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';
import PlusApi from '@/api/plus.js';
export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        type:0,//1  基础获取类  2 修改类
        table:"",
        id:"",
        note:"",
        putController:"",
        condi:"",

        zname:"",
        znameen:"",
        phppath:'/Applications/phpstudy/WWW/shanghui.1.y01.cn/',
        shoppath:'/Volumes/macDs/慧行项目/2025-12/连锁门店/',
        uniapppath:'/Volumes/macDs/慧行项目/2025-12/连锁门店/杏小方/components/diy/',

      
      },
      formplus:{
        plus_name:"",
        plus_name_english:"",
        shop_gen_url:"E:\\项目\\2024-5\\康采\\",
        php_gen_url:"D:\\phpstudy_pro\\WWW\\",
        hosturl:"hxing.1.y01.cn",
        new_access_id:0,
        fields:[]


      },
      showNmae:'',
      loading: false,
      result:[]
    };
  },
  created() {

  },

  methods: {
      delOrder(index){
        this.formplus.fields.splice(index,1)
    },
      addOrder(){
        this.formplus.fields.push({
          "name":"",
        });
      },
    onSubmitPlus(code){
      let self = this;
      let parmas = self.formplus;
      parmas.code = code;
      PlusApi.genPlus(parmas, true)
        .then(res => {
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.genCode(params, true)
        .then(data => {
          self.loading = false;

          self.result = data.data
          for(var i=0;i<self.result.length;i++){
            self.result[i].val.replace(/\r\n/g, "<br/>")
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    onSubmitdiyz(type) {
      let self = this;
      self.loading = true;
      let params = this.form;
      params.type = type
      SettingApi.gendiyz(params, true)
        .then(data => {
          self.loading = false;

  
        })
        .catch(error => {
          self.loading = false;
        });
    },
    deldiyz() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.deldiyz(params, true)
        .then(data => {
          self.loading = false;

  
        })
        .catch(error => {
          self.loading = false;
        });
    },


  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/way/index.vue